import React, { memo } from 'react';
import { PercentageContainer, ProgressStyled } from '../styles';

export const LeadProgress = memo(({ percentage }) => {
  if (!percentage) return null;
  
  return (
    <PercentageContainer>
      <ProgressStyled percent={percentage} />
    </PercentageContainer>
  );
});

LeadProgress.displayName = 'LeadProgress';